import { Text } from "@ttc3k/trekker";
import { Flex } from "styled-system/jsx";
import { CopyToClipboard } from "shared/components";

type ShareLinkBoxProps = {
  url: string;
};

export const ShareLinkBox = ({ url }: ShareLinkBoxProps) => (
  <Flex
    alignItems="center"
    justifyContent="space-between"
    gap="100"
    px="150"
    py="100"
    bgColor="white"
    border="2px solid"
    borderColor="border.dark"
    borderRadius="100"
    w="full"
  >
    <Text visual="" color="text.light" lineClamp={1} wordBreak="break-all">
      {url}
    </Text>
    <CopyToClipboard
      text={url}
      alternateDisplayText="Copy"
      color="text.light"
      _hover={{ color: "text.mid" }}
      _focusVisible={{ color: "text.mid" }}
      transitionProperty="color"
      transitionDuration="normal"
      transitionTimingFunction="default"
      buttonProps={{ flexShrink: 0 }}
    />
  </Flex>
);
